import $ from 'jquery';

import { AuthError } from './auth';
import { LoaderError } from './loader';
import { TextId, TextSelector } from './textSelector';
import { Speaker } from './speaker';

declare let speaker: Speaker;

declare let defaultDbTextSelector: TextSelector;
export class Announcement {
  private static showCustomModal(
    textHtml: string,
    resolve: (() => void) | null,
    allowKeyboardClose = true,
    keyboardCloseDelayMs = 0,
  ) {
    let keyupTimeout: number | null = null;
    const closeModal = () => {
      $('#announcementModal').hide();
      $('#overlayModal').off('click', closeModal);
      $('#announcementClose').off('click', closeModal);
      $(document).off('keyup', closeModal);
      if (keyupTimeout) {
        window.clearTimeout(keyupTimeout);
        keyupTimeout = null;
      }
      resolve && resolve();
    };

    $('#modalText').html(textHtml);
    Announcement.announcementBlockadeActive = false;
    $('#announcementClose').show();
    $('#announcementDot').hide();
    $('#announcementModal').show();

    $('#overlayModal').on('click', closeModal);
    $('#announcementClose').on('click', closeModal);
    if (allowKeyboardClose) {
      if (keyboardCloseDelayMs > 0) {
        keyupTimeout = window.setTimeout(() => {
          $(document).on('keyup', closeModal);
        }, keyboardCloseDelayMs);
      } else {
        $(document).on('keyup', closeModal);
      }
    }
  }

  private static getLoaderErrorTextId(error: LoaderError) {
    switch (error.statusCode) {
      case 403:
        return { textId: 'wrong_pin_403', message: error.message };
      case 404:
        return { textId: 'wrong_pin_404', message: error.message };
      case 500:
        return { textId: 'wrong_pin_500', message: error.message };
      case 0:
        return { textId: 'wrong_pin_0', message: error.message };
      default:
        return { textId: 'wrong_pin_unknown', message: '' };
    }
  }

  public static announcementBlockadeActive = false;
  public static announcementBlockade(
    textId: TextId,
    must_read = false,
    orgMessage = '',
  ) {
    const text = defaultDbTextSelector.getText(textId);
    void speaker.playSoundOrSpeakText(text.text_read, must_read, text.sound);
    $('#modalText').html(
      text.text_presentation +
        (orgMessage ? '<br/><small>' + orgMessage + '</small>' : ''),
    );
    $('#announcementClose').hide();
    $('#announcementDot').show();
    $('#announcementModal').show();
    Announcement.announcementBlockadeActive = true;
  }

  public static closeBlockade() {
    if (!Announcement.announcementBlockadeActive) {
      return;
    }
    Announcement.announcementBlockadeActive = false;
    $('#announcementClose').show();
    $('#announcementDot').hide();
    $('#announcementModal').hide();
  }

  public static announcementAboutBlockingError(
    textId: TextId,
    must_read = false,
    orgMessage = '',
  ) {
    Announcement.announcementAbout(textId, must_read, orgMessage);
    window.dispatchEvent(new CustomEvent('blockingError', { detail: textId }));
  }

  public static announcementAbout(
    textId: TextId,
    must_read = false,
    orgMessage = '',
    resolve: (() => void) | null = null, /// do obsłużenia przypadku async można przekazać promise
    allowKeyboardClose = true,
    keyboardCloseDelayMs = 0,
  ) {
    let keyupTimeout: number | null = null;
    const closeModal = () => {
      $('#announcementModal').hide();
      $('#overlayModal').off('click', closeModal);
      $('#announcementClose').off('click', closeModal);
      $(document).off('keyup', closeModal);
      if (keyupTimeout) {
        window.clearTimeout(keyupTimeout);
        keyupTimeout = null;
      }
      resolve && resolve(); // w wariancie async
    };

    const text = defaultDbTextSelector.getText(textId);
    void speaker.playSoundOrSpeakText(text.text_read, must_read, text.sound);

    if (orgMessage) {
      $('#modalText').html(
        text.text_presentation + '<br/><small>[' + orgMessage + ']</small>',
      );
    } else {
      $('#modalText').html(text.text_presentation);
    }

    $('#announcementModal').show();

    $('#overlayModal').on('click', closeModal);
    $('#announcementClose').on('click', closeModal);
    if (allowKeyboardClose) {
      if (keyboardCloseDelayMs > 0) {
        keyupTimeout = window.setTimeout(() => {
          $(document).on('keyup', closeModal);
        }, keyboardCloseDelayMs);
      } else {
        $(document).on('keyup', closeModal);
      }
    }
  }

  public static announcementAlert(
    textId: TextId,
    must_read = false,
    orgMessage = '',
    allowKeyboardClose = true,
    keyboardCloseDelayMs = 0,
  ): Promise<void> {
    return new Promise(resolve => {
      Announcement.announcementAbout(
        textId,
        must_read,
        orgMessage,
        resolve,
        allowKeyboardClose,
        keyboardCloseDelayMs,
      );
    });
  }

  public static announcementCustomAlert(
    textHtml: string,
    allowKeyboardClose = true,
    keyboardCloseDelayMs = 0,
    readText?: string,
    must_read = false,
  ): Promise<void> {
    if (readText) {
      void speaker.playSoundOrSpeakText(readText, must_read);
    }
    return new Promise(resolve => {
      Announcement.showCustomModal(
        textHtml,
        resolve,
        allowKeyboardClose,
        keyboardCloseDelayMs,
      );
    });
  }

  public static forceCloseAnnouncementModal() {
    $('#announcementModal').hide();
    $('#overlayModal').off('click');
    $('#announcementClose').off('click');
    $(document).off('keyup');
    Announcement.announcementBlockadeActive = false;
    $('#announcementClose').show();
    $('#announcementDot').hide();
  }

  public static async announcementLoaderErrorForPINAsync(error: LoaderError) {
    const { textId, message } = Announcement.getLoaderErrorTextId(error);
    // Krótkie opóźnienie: zapobiega natychmiastowemu zamknięciu modala
    // przez keyup po wciśnięciu Enter przy zatwierdzaniu PIN-u.
    await Announcement.announcementAlert(textId, false, message, true, 300);
  }

  public static announcementAuthError(error: AuthError) {
    switch (error.code) {
      case 'auth/invalid-email':
      case 'auth/user-disabled':
      case 'auth/user-not-found':
      case 'auth/wrong-password':
        Announcement.announcementAbout('wrong_user_psw', false);
        break;
      case 'auth/network-request-failed':
        Announcement.announcementAbout('no_connection', false);
        break;
      case 'auth/invalid-token':
        Announcement.announcementAbout('auth_invalid_token', false);
        break;
      default:
        Announcement.announcementAbout('auth_unknown', false, error.message);
    }
  }
}
